module.exports = __webpack_public_path__ + "img/clogo.b7c0c96e.png";